export default __webpack_public_path__ + "media/music/1f0cb1e9a38c036c369737349a694c1f.mp3";